import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import Danny from "./Avatars/Messages_Danny.jpg";
import MamaM from "./Avatars/Messages_MamaM.jpg";
import Rosa from "./Avatars/Messages_Rosa.jpg";
import Roaming from "./Avatars/Messages_Tecro_Roaming.jpg";

import { LeoGif } from "./InfluencerPhotoContent";

export const influencerMessageContent: Chat_content[] = [
  {
    icon: Rosa,
    type: "individual",
    name: "Rosa",
    messages: [
      {
        content: {
          type: "text",
          content: "You okay up there? Need anything?",
        },
        timestamp: "2024-05-26T14:12:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "these pains are killing me 😖😖",
        },
        timestamp: "2024-05-26T14:27:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I need painkillers. Can you get me some Oxycontin they sell it over the counter here?",
        },
        timestamp: "2024-05-26T14:27:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "You sure that's safe?",
        },
        timestamp: "2024-05-26T14:29:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "with the baby I mean",
        },
        timestamp: "2024-05-26T14:29:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "my doc says I can take it pls just get it for me quick I’m dying 🤒",
        },
        timestamp: "2024-05-26T14:30:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "K I'll ask the hotel staff to get it and bring it to room",
        },
        timestamp: "2024-05-26T14:34:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "thx 😘",
        },
        timestamp: "2024-05-26T14:34:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "one more thing",
        },
        timestamp: "2024-05-26T14:35:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I need you to drink for me tonight at the party",
        },
        timestamp: "2024-05-26T14:36:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "what",
        },
        timestamp: "2024-05-26T14:40:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "so no one finds out I'm pregnant obvs",
        },
        timestamp: "2024-05-26T14:41:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Are you still gonna come?",
        },
        timestamp: "2024-05-26T14:43:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Yeah I don’t want people thinking there’s something up with us after the Pete stuff",
        },
        timestamp: "2024-05-26T14:44:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "alright yeah I’ll drink for you",
        },
        timestamp: "2024-05-26T14:45:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: LeoGif,
        },
        timestamp: "2024-05-26T14:47:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "ly x",
        },
        timestamp: "2024-05-26T14:47:00Z",
        from: "Rosa",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "love you too x",
        },
        timestamp: "2024-05-26T14:53:00Z",
        from: "Josh",
        status: "Read",
      },
    ],
    read: false,
  },
  {
    icon: Danny,
    type: "individual",
    name: "Danny",
    messages: [
      {
        content: {
          type: "text",
          content: "Which room you in?",
        },
        timestamp: "2024-05-25T14:27:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "212",
        },
        timestamp: "2024-05-25T14:28:00Z",
        from: "Danny",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I need to speak to u in person. about some debts I got.",
        },
        timestamp: "2024-05-26T12:05:00Z",
        from: "Danny",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "can u drop it we’re in bali",
        },
        timestamp: "2024-05-26T12:07:00Z",
        from: "Josh",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "it’s real urgent i need ur help",
        },
        timestamp: "2024-05-26T12:07:00Z",
        from: "Danny",
        status: "Read",
      },
      {
        content: {
          type: "missed-call",
          content: "Missed audio call from Danny 12:08pm",
        },
        timestamp: "2024-05-26T12:07:00Z",
        from: "Danny",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "if ur ever in trouble in future , dont come knocking for me",
        },
        timestamp: "2024-05-26T12:24:00Z",
        from: "Danny",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "thats it for us now josh may as well not call u my brother anymore",
        },
        timestamp: "2024-05-26T12:24:00Z",
        from: "Danny",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "u always were a greedy money obsessed heartless bastard",
        },
        timestamp: "2024-05-26T12:25:00Z",
        from: "Danny",
        status: "Read",
      },
    ],
    read: false,
  },
  {
    icon: MamaM,
    type: "individual",
    name: "Mama M",
    messages: [
      {
        content: {
          type: "text",
          content: "How’s the journey been?xx",
        },
        timestamp: "2024-05-24T11:02:00Z",
        from: "Mama M",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Yes, all fine. Just landed with the whole crew and Danny. The island is lovely and the hotel is beautiful. Our suite has the most amazing view x",
        },
        timestamp: "2024-05-24T11:56:00Z",
        from: "Josh",
        status: "Read",
      },
    ],
    read: true,
  },
  {
    icon: Roaming,
    type: "individual",
    name: "Tecro",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Halo! Top up your sim with 20,000 Rp today, and enjoy 30 days of FREE WhatsApp usage PLUS 600 minutes of free calls. Stay connected, and seize the deal! 🌐✨…",
        },
        timestamp: "2024-05-24T11:27:00Z",
        from: "Tecro",
        status: "Unread",
      },
    ],
    read: true,
  },
  {
    icon: Roaming,
    type: "individual",
    name: "Roaming",
    messages: [
      {
        content: {
          type: "text",
          content:
            "Welcome to INDONESIA. If you want to use data while you’re here, you’ll need to buy a Zone 1 Power Charge. See our pricing here (it’s free to view) …",
        },
        status: "Unread",
        timestamp: "2024-05-24T11:27:00Z",
        from: "O2 Roaming",
      },
    ],
    read: true,
  },
];
